module.exports = __webpack_public_path__ + "img/rockettubes_stickers.44af2908.png";